import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "menu__element-text" }
const _hoisted_4 = { class: "menu__element" }
const _hoisted_5 = { class: "menu__element-text" }
const _hoisted_6 = { class: "jobs-list" }
const _hoisted_7 = {
  key: 0,
  class: "jobs-list__divider"
}
const _hoisted_8 = { class: "menu__element-text" }

import AppIcon from "../ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "../ui-kit/dropdown/AppResizableDropdown.vue";
import FileJobElement from "./FileJobElement.vue";
import { JobsApi } from "@/ api/JobsApi";
import { Job, JobInfo } from "@/store/jobs";
import { clientPageStore } from "@/store/client-page";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { JobBinding } from "@/models/interfaces/file/file-model";
import { navigateToJob } from "./jobNavigation";

interface menuElement {
  name: string;
  nameIcon: string;
  event: string;
}

interface Props {
  elements: menuElement[];
  type?: "file" | "folder";
  JobBindings?: JobBinding[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileMenu',
  props: {
    elements: {},
    type: { default: "folder" },
    JobBindings: {}
  },
  emits: ["select", "jobs-closed", "job-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const clientStore = clientPageStore();
const jobAccess = clientStore.client?.JobAccess;
const isJobsOpen = ref(false);

const handleJobsOpen = () => {
  isJobsOpen.value = true;
};
const handleJobsClose = () => {
  isJobsOpen.value = false;
  emit("jobs-closed");
};

const jobs = ref<JobInfo[]>();

onMounted(async () => {
  jobs.value = props.JobBindings
    ? await Promise.all(
        props.JobBindings.map((el) => JobsApi.getJobInfo(el.JobId)),
      )
    : undefined;
});

const emit = __emit;

const chooseAction = (option: string) => {
  emit("select", option);
};

const route = useRoute();
const router = useRouter();

const onJobSelected = (job: Job) => {
  emit("job-selected");
  navigateToJob(job, route, router);
};

const onSingleJobClick = () => {
  const single = jobs.value?.[0]?.Job;
  if (!single) return;
  onJobSelected(single);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element) => {
      return (_openBlock(), _createElementBlock("div", {
        key: element.name,
        class: "menu__element",
        onClick: ($event: any) => (chooseAction(element.event))
      }, [
        _createVNode(AppIcon, {
          name: element.nameIcon,
          width: "16px",
          color: "#979797",
          cursor: "pointer"
        }, null, 8, ["name"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(element.name), 1)
      ], 8, _hoisted_2))
    }), 128)),
    (props.JobBindings?.length > 1 && _unref(jobAccess)!==0)
      ? (_openBlock(), _createBlock(AppResizableDropdown, {
          key: 0,
          position: "right",
          resizable: false,
          trigger: "hover",
          "hover-delay": 300,
          "hover-close-delay": 300,
          "close-by-click-outside": false,
          "max-width": 320,
          "max-height": 236,
          "mobile-title": _ctx.$t('choose_job'),
          ref: "$jobWindow",
          onOpen: handleJobsOpen,
          onClose: handleJobsClose
        }, {
          activator: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(AppIcon, {
                name: "go-job",
                width: "16px",
                color: "#979797",
                cursor: "pointer"
              }),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("file_go_to_job")), 1),
              _createVNode(AppIcon, {
                name: "chevron-left",
                class: "menu__element-chevron",
                width: "16px",
                color: "#979797",
                cursor: "pointer"
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobs.value, (job, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: job.Job.Id
                }, [
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true),
                  _createVNode(FileJobElement, {
                    job: job.Job,
                    onSelectJob: onJobSelected
                  }, null, 8, ["job"])
                ], 64))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["mobile-title"]))
      : (props.JobBindings?.length == 1 && _unref(jobAccess)!==0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["menu__element", { 'menu__element--disabled': !jobs.value?.length }]),
            onClick: onSingleJobClick
          }, [
            _createVNode(AppIcon, {
              name: "go-job",
              width: "16px",
              color: "#979797",
              cursor: "pointer"
            }),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("file_go_to_job")), 1)
          ], 2))
        : _createCommentVNode("", true)
  ]))
}
}

})